var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scanningStock" }, [
    _c(
      "div",
      { staticClass: "head" },
      [
        _c("span", [_vm._v("当前扫描箱码:")]),
        _vm._v(" "),
        _c("el-input", {
          ref: "input",
          nativeOn: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              ) {
                return null
              }
              return _vm.scanning.apply(null, arguments)
            }
          },
          model: {
            value: _vm.scanningBox,
            callback: function($$v) {
              _vm.scanningBox = $$v
            },
            expression: "scanningBox"
          }
        }),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", size: "small" },
            on: { click: _vm.saveScanning }
          },
          [_vm._v("保存")]
        ),
        _vm._v(" "),
        _c(
          "el-button",
          {
            attrs: { type: "primary", loading: _vm.stockOut, size: "small" },
            on: { click: _vm.confirmStock }
          },
          [_vm._v("确定出库")]
        )
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "flex" }, [
      _c(
        "div",
        { staticClass: "main-left" },
        [
          _c("div", { staticClass: "title" }, [_vm._v("当前扫描统计:")]),
          _vm._v(" "),
          _c("div", { staticClass: "scanning" }, [
            _c("div", [
              _c("span", [_vm._v("扫描完成主单数：")]),
              _c("span", { staticClass: "green" }, [
                _vm._v(_vm._s(_vm.main_number_count))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "right" }, [_vm._v("扫描箱数：")]),
              _c("span", { staticClass: "green" }, [
                _vm._v(_vm._s(_vm.box_count))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("span", [_vm._v("扫描不完整主单：")]),
              _c("span", { staticClass: "red" }, [
                _vm._v(_vm._s(_vm.incomplete_count))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "right" }, [_vm._v("待出库主单数：")]),
              _c("span", { staticClass: "blue" }, [
                _vm._v(_vm._s(_vm.wait_stock_count))
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [_vm._v("扫描记录")]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.scanningTableData,
                "span-method": _vm.objectSpanMethod,
                border: ""
              }
            },
            [
              _c("el-table-column", {
                attrs: { prop: "main_number", label: "主订单号", width: "150" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "serial_number", label: "编号", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.serial_number
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.serial_number
                                    .split("-")
                                    .slice(3)
                                    .join("-")
                                )
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "boxs", label: "箱码", width: "180" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "状态" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.status === true
                          ? _c("i", { staticClass: "el-icon-circle-check" })
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "time", label: "扫描时间", width: "130" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-right" },
        [
          _c(
            "div",
            { staticClass: "title" },
            [
              _vm._v("\n        日出库统计\n        "),
              _vm._v(" "),
              _c("el-input", {
                attrs: { disabled: true },
                model: {
                  value: _vm.currentDay,
                  callback: function($$v) {
                    _vm.currentDay = $$v
                  },
                  expression: "currentDay"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "today-stock" }, [
            _c("div", [
              _c("span", [_vm._v("今日出库主单数：")]),
              _c("span", { staticClass: "green" }, [
                _vm._v(_vm._s(_vm.current_stock_count))
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "right" }, [
                _vm._v("今日出库总箱数：")
              ]),
              _c("span", { staticClass: "green" }, [
                _vm._v(_vm._s(_vm.current_box_count))
              ])
            ])
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.showCurrentTable,
                  expression: "showCurrentTable"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.completeTableData,
                border: "",
                height: "600px"
              }
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "main_number", label: "主订单号", width: "160" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "serial_number", label: "编号", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.serial_number
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  scope.row.serial_number
                                    .split("-")
                                    .slice(3)
                                    .join("-")
                                )
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "box_num", label: "出库箱数" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "oper_time", label: "出库时间", width: "130" }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3d240310", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d240310","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/order/scanningStock.vue
// module id = null
// module chunks = 